import {Flag} from 'platform/components';
import {Show} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

import i18n from '../../../../../i18n/i18n';
import {RelativeFilterResponseBody} from '../../../../../types/api/api';

interface PresetBadgesProps extends TestIdProps {
  preset: RelativeFilterResponseBody;
}

/**
 * Flags a preset carries next to its name: the backend-managed system preset
 * ("Přesná shoda") gets a light-grey "Systémový" badge, the default preset a blue one.
 */
export function PresetBadges(props: PresetBadgesProps) {
  return (
    <>
      <Show when={props.preset.system}>
        <Flag
          label={i18n.t('entity.filterForm.savedFilters.systemBadge')}
          size="small"
          colorScheme="neutral"
          isSubtle
          data-testid={suffixTestId('systemBadge', props)}
        />
      </Show>
      <Show when={props.preset.default}>
        <Flag
          label={i18n.t('entity.filterForm.savedFilters.defaultBadge')}
          size="small"
          colorScheme="blue"
          isSubtle
          data-testid={suffixTestId('defaultBadge', props)}
        />
      </Show>
    </>
  );
}
